import { useQuery, keepPreviousData } from "@tanstack/react-query";

import { getAuditLog, type GetAuditLogParams } from "../../services/auditLog";

export type { GetAuditLogParams };

export function useAuditLog(params: GetAuditLogParams = {}) {
  return useQuery({
    queryKey: ["audit-log", params],
    queryFn: () => getAuditLog(params),
    placeholderData: keepPreviousData,
  });
}
